import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'rdx-map-debug',
    templateUrl: './map-debug.component.html',
    standalone: true,
    imports: [NgStyle],
})
export class MapDebugComponent {
    @Input() isDebug: boolean;
    @Input() isLeft: boolean;
    @Input() north: number;
    @Input() mouseLat: number;
    @Input() south: number;
    @Input() east: number;
    @Input() mouseLng: number;
    @Input() west: number;
    @Input() zoom: number;
    @Input() layers: string[];
}
